import { IconTrash, ImageIcon } from "./Icons";

export const PreviewItem = ({ image, index, remove, onPreview, onlyView }) => {
  return (
    <div
      key={image.id}
      className="group relative aspect-square rounded-xl overflow-hidden border border-gray-100 bg-white shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer"
      onClick={() => onPreview(index)}
    >
      <img
        src={image.path}
        alt="preview"
        className="w-full h-full object-cover rounded-xl transition-transform duration-500 group-hover:scale-105"
      />

      {!onlyView && (
        <div className="absolute inset-0 bg-black/40 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-3">
          <button
            className="p-1 bg-white/80 text-red-600 outline-none rounded-lg hover:bg-white shadow-lg transition-all transform hover:scale-110 active:scale-95"
            onClick={(e) => {
              e.stopPropagation();
              remove(index);
            }}
            title="Xóa ảnh"
          >
            <IconTrash size={18} />
          </button>
          <button
            className="p-1 bg-white/80 text-blue-600 outline-none rounded-lg hover:bg-white shadow-lg transition-all transform hover:scale-110 active:scale-95"
            title="Phóng to"
          >
            <ImageIcon size={18} />
          </button>
        </div>
      )}

      <div className="absolute top-1 left-1 bg-white/80 backdrop-blur-md text-gray-800 text-[10px] font-bold px-2 py-0.5 rounded-md border border-gray-200 shadow-sm">
        {index + 1}
      </div>
    </div>
  );
};
